import React from "react";
import { connect } from "react-redux";
import ReactGA from "react-ga4";

import {
  CategoryNameHr,
  ModuleNameHr,
  PageRoute,
  QueryParam
} from "../../../models";
import { AdsSortOption } from "../../../models/enums";
import { stringifyURI, setRecentSearchQuery } from "../../../services";
import { selectControlFields } from "../../../routes/Search/search.ducks";
import { selectCurrentModule } from "../../App/selectors";
import history from "../../../history";

import styles from "./QuickSearches.scss";
import { GOLF_MODEL_IDS } from "../../../carModelIds";

interface QuickSearch {
  label: string;
  pathSlug?: string;
  searchParams: Record<string, any>;
}

interface QuickSearchesConfig {
  title: string;
  moduleHr: string;
  categoryHr: string;
  searches: QuickSearch[];
}

const quickSearchConfigs: Record<string, QuickSearchesConfig> = {
  [CategoryNameHr.car]: {
    title: "Brze pretrage",
    moduleHr: ModuleNameHr.vehicles,
    categoryHr: CategoryNameHr.car,
    searches: [
      {
        label: "BMW do 8.000 €",
        pathSlug: "bmw",
        searchParams: {
          includeMakeIds: ["cb168b9e-e921-4138-98bc-21b39b69208f"],
          priceTo: "8000",
        },
      },
      {
        label: "Golf do 5.000 €",
        searchParams: {
          includeModelIds: GOLF_MODEL_IDS,
          priceTo: "5000",
        },
      },
      {
        label: "Audi A4 Zagreb",
        searchParams: {
          includeCountyIds: ["056b6c84-e6f1-433f-8bdc-9b8dbb86d6fb"],
          includeModelIds: [
            "631dc155-cbeb-4769-8116-094cd7c39c2c",
            "c81b3fa7-8beb-4953-bbd5-ef66e60bbeec",
            "1078dd32-c992-49a5-b113-12940708a81c",
            "c8a90baa-4959-44ca-8233-b1960770f2cf",
          ],
        },
      },
      {
        label: "SUV do 15.000 €",
        searchParams: {
          priceTo: "15000",
          vehicleBodyTypes: [5],
        },
      },
      {
        label: "Automatik do 10.000 €",
        searchParams: {
          priceTo: "10000",
          gearboxIds: [2, 3],
        },
      },
    ],
  },
  [CategoryNameHr.flatsForSale]: {
    title: "Brze pretrage",
    moduleHr: ModuleNameHr.realEstate,
    categoryHr: CategoryNameHr.flatsForSale,
    searches: [
      {
        label: "Oglasi agencija",
        searchParams: {
          legalEntity: 2,
        },
      },
      {
        label: "Oglasi privatnih prodavača",
        searchParams: {
          legalEntity: 1,
        },
      },
      {
        label: "Stan Zagreb do 150.000 €",
        pathSlug: "grad-zagreb",
        searchParams: {
          includeCountyIds: ["056b6c84-e6f1-433f-8bdc-9b8dbb86d6fb"],
          priceTo: "150000",
        },
      },
      {
        label: "Stan Zagreb do 200.000 €",
        pathSlug: "grad-zagreb",
        searchParams: {
          includeCountyIds: ["056b6c84-e6f1-433f-8bdc-9b8dbb86d6fb"],
          priceTo: "200000",
        },
      },
      {
        label: "Stan Split do 200.000 €",
        pathSlug: "split",
        searchParams: {
          priceTo: "200000",
          includeCityIds: ["52eb9db8-6dc1-4ed5-acf7-e1669df05240"],
        },
      },
      {
        label: "Stan Rijeka do 150.000 €",
        pathSlug: "rijeka",
        searchParams: {
          priceTo: "150000",
          includeCityIds: ["36bd1dbc-f301-4ae7-988e-171765d599f7"],
        },
      },
    ],
  },
};

interface QuickSearchesProps {
  categoryHr: string;
  module?: string;
  controlFields?: any;
}

const QuickSearches: React.FC<QuickSearchesProps> = ({ categoryHr, controlFields = {} }) => {
  const config = quickSearchConfigs[categoryHr];

  if (!config) {
    return null;
  }

  const handleClick = (search: QuickSearch) => {
    const params = {
      category: config.categoryHr,
      module: config.moduleHr,
      sortOption: AdsSortOption.DateDesc,
      ...search.searchParams,
    };

    ReactGA.event({
      category: "Brze pretrage",
      action: "Click",
      label: search.label,
    });

    setRecentSearchQuery(config.categoryHr, { ...params }, controlFields);

    const queryUrl = stringifyURI(params, QueryParam.searchQuery);
    const slugPart = search.pathSlug ? `/${search.pathSlug}` : "";
    history.push(`/${config.moduleHr}/${config.categoryHr}${slugPart}${PageRoute.search}${queryUrl}`);
  };

  return (
    <div className={`${styles.quickSearches} ${config.moduleHr === ModuleNameHr.realEstate ? styles.realEstate : ""}`}>
      <span className={styles.title}>{config.title}</span>
      <div className={styles.pills}>
        {config.searches.map((search) => (
          <a
            key={search.label}
            className={styles.pill}
            onClick={() => handleClick(search)}
          >
            {search.label}
          </a>
        ))}
      </div>
    </div>
  );
};

export default connect(
  state => ({
    module: selectCurrentModule(state),
    controlFields: selectControlFields(state),
  })
)(QuickSearches);



// WEBPACK FOOTER //
// ./src/containers/ModulePage/QuickSearches/QuickSearches.tsx